/* tslint:disable */
/* eslint-disable */
/**
 * Seamworks API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SingleThreadConsumptionReportDto } from '../model/';
// @ts-ignore
import type { ThreadConsumptionReportDto } from '../model/';
/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [currentCulture] 
         * @param {boolean} [includeCost] 
         * @param {number} [noOfGarments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSingleGarmentIdGet: async (id: number, currentCulture?: string, includeCost?: boolean, noOfGarments?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportSingleGarmentIdGet', 'id', id)
            const localVarPath = `/api/report/singleGarment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (currentCulture !== undefined) {
                localVarQueryParameter['currentCulture'] = currentCulture;
            }

            if (includeCost !== undefined) {
                localVarQueryParameter['includeCost'] = includeCost;
            }

            if (noOfGarments !== undefined) {
                localVarQueryParameter['noOfGarments'] = noOfGarments;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [includeCost] 
         * @param {number} [noOfGarments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSingleGarmentPdfIdGet: async (id: number, includeCost?: boolean, noOfGarments?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportSingleGarmentPdfIdGet', 'id', id)
            const localVarPath = `/api/report/singleGarmentPdf/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (includeCost !== undefined) {
                localVarQueryParameter['includeCost'] = includeCost;
            }

            if (noOfGarments !== undefined) {
                localVarQueryParameter['noOfGarments'] = noOfGarments;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [noOfGarments] 
         * @param {number} [noOfProdLines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportThreadGarmentPdfIdGet: async (id: number, noOfGarments?: number, noOfProdLines?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportThreadGarmentPdfIdGet', 'id', id)
            const localVarPath = `/api/report/threadGarmentPdf/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (noOfGarments !== undefined) {
                localVarQueryParameter['noOfGarments'] = noOfGarments;
            }

            if (noOfProdLines !== undefined) {
                localVarQueryParameter['noOfProdLines'] = noOfProdLines;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [currentCulture] 
         * @param {number} [noOfGarments] 
         * @param {number} [noOfProdLines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportThreadUsageIdGet: async (id: number, currentCulture?: string, noOfGarments?: number, noOfProdLines?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportThreadUsageIdGet', 'id', id)
            const localVarPath = `/api/report/threadUsage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (currentCulture !== undefined) {
                localVarQueryParameter['currentCulture'] = currentCulture;
            }

            if (noOfGarments !== undefined) {
                localVarQueryParameter['noOfGarments'] = noOfGarments;
            }

            if (noOfProdLines !== undefined) {
                localVarQueryParameter['noOfProdLines'] = noOfProdLines;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [currentCulture] 
         * @param {boolean} [includeCost] 
         * @param {number} [noOfGarments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportSingleGarmentIdGet(id: number, currentCulture?: string, includeCost?: boolean, noOfGarments?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportSingleGarmentIdGet(id, currentCulture, includeCost, noOfGarments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.apiReportSingleGarmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [includeCost] 
         * @param {number} [noOfGarments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportSingleGarmentPdfIdGet(id: number, includeCost?: boolean, noOfGarments?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleThreadConsumptionReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportSingleGarmentPdfIdGet(id, includeCost, noOfGarments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.apiReportSingleGarmentPdfIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [noOfGarments] 
         * @param {number} [noOfProdLines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportThreadGarmentPdfIdGet(id: number, noOfGarments?: number, noOfProdLines?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadConsumptionReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportThreadGarmentPdfIdGet(id, noOfGarments, noOfProdLines, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.apiReportThreadGarmentPdfIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [currentCulture] 
         * @param {number} [noOfGarments] 
         * @param {number} [noOfProdLines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportThreadUsageIdGet(id: number, currentCulture?: string, noOfGarments?: number, noOfProdLines?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportThreadUsageIdGet(id, currentCulture, noOfGarments, noOfProdLines, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.apiReportThreadUsageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [currentCulture] 
         * @param {boolean} [includeCost] 
         * @param {number} [noOfGarments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSingleGarmentIdGet(id: number, currentCulture?: string, includeCost?: boolean, noOfGarments?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiReportSingleGarmentIdGet(id, currentCulture, includeCost, noOfGarments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [includeCost] 
         * @param {number} [noOfGarments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSingleGarmentPdfIdGet(id: number, includeCost?: boolean, noOfGarments?: number, options?: RawAxiosRequestConfig): AxiosPromise<SingleThreadConsumptionReportDto> {
            return localVarFp.apiReportSingleGarmentPdfIdGet(id, includeCost, noOfGarments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [noOfGarments] 
         * @param {number} [noOfProdLines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportThreadGarmentPdfIdGet(id: number, noOfGarments?: number, noOfProdLines?: number, options?: RawAxiosRequestConfig): AxiosPromise<ThreadConsumptionReportDto> {
            return localVarFp.apiReportThreadGarmentPdfIdGet(id, noOfGarments, noOfProdLines, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [currentCulture] 
         * @param {number} [noOfGarments] 
         * @param {number} [noOfProdLines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportThreadUsageIdGet(id: number, currentCulture?: string, noOfGarments?: number, noOfProdLines?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiReportThreadUsageIdGet(id, currentCulture, noOfGarments, noOfProdLines, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {string} [currentCulture] 
     * @param {boolean} [includeCost] 
     * @param {number} [noOfGarments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public apiReportSingleGarmentIdGet(id: number, currentCulture?: string, includeCost?: boolean, noOfGarments?: number, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).apiReportSingleGarmentIdGet(id, currentCulture, includeCost, noOfGarments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [includeCost] 
     * @param {number} [noOfGarments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public apiReportSingleGarmentPdfIdGet(id: number, includeCost?: boolean, noOfGarments?: number, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).apiReportSingleGarmentPdfIdGet(id, includeCost, noOfGarments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} [noOfGarments] 
     * @param {number} [noOfProdLines] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public apiReportThreadGarmentPdfIdGet(id: number, noOfGarments?: number, noOfProdLines?: number, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).apiReportThreadGarmentPdfIdGet(id, noOfGarments, noOfProdLines, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [currentCulture] 
     * @param {number} [noOfGarments] 
     * @param {number} [noOfProdLines] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public apiReportThreadUsageIdGet(id: number, currentCulture?: string, noOfGarments?: number, noOfProdLines?: number, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).apiReportThreadUsageIdGet(id, currentCulture, noOfGarments, noOfProdLines, options).then((request) => request(this.axios, this.basePath));
    }
}

